module.exports = __webpack_public_path__ + "static/media/6.1_preview.26678b65.png";